import { render, staticRenderFns } from "./EmailSendConfirmation.vue?vue&type=template&id=e0a5ddec&scoped=true&"
import script from "./EmailSendConfirmation.vue?vue&type=script&lang=js&"
export * from "./EmailSendConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./EmailSendConfirmation.vue?vue&type=style&index=0&id=e0a5ddec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a5ddec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
